var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2c3e50;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    className: "cls-1",
    d: "M21.41,12.86a6,6,0,0,0-.17-2.75l-.32-1.06a2.3,2.3,0,0,0-4.34,0l-.32,1.06a6,6,0,0,0-.17,2.75,2.61,2.61,0,0,0,1.33,1.8l-.36,8a1.61,1.61,0,0,0,.4,1.23,1.75,1.75,0,0,0,2.47.11.57.57,0,0,0,.11-.11,1.55,1.55,0,0,0,.4-1.2l-.36-8.07a2.61,2.61,0,0,0,1.33-1.8m-1-.17a1.56,1.56,0,0,1-1,1.19.5.5,0,0,0-.33.49l.38,8.44a.56.56,0,0,1-.15.46.78.78,0,0,1-1.08,0,.6.6,0,0,1-.15-.49l.38-8.41a.5.5,0,0,0-.33-.49,1.56,1.56,0,0,1-1-1.19,4.93,4.93,0,0,1,.13-2.29l.32-1.05a1.3,1.3,0,0,1,2.44,0l.32,1.05a4.93,4.93,0,0,1,.13,2.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    className: "cls-1",
    d: "M13.85,12.85A.49.49,0,0,0,14,12.5V8a.5.5,0,0,0-1,0v4.29l-1.35,1.35a.5.5,0,0,0-.15.38l.44,8.75a.69.69,0,0,1-.19.51.71.71,0,0,1-1,0h0a.69.69,0,0,1-.19-.51L11,14a.5.5,0,0,0-.15-.38L9.5,12.29V8a.5.5,0,0,0-1,0v4.5a.49.49,0,0,0,.15.35L10,14.19l-.43,8.53a1.69,1.69,0,0,0,3.38.17h0v-.17l-.43-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    className: "cls-1",
    d: "M10.5,12.5A.5.5,0,0,0,11,12V8a.5.5,0,0,0-1,0v4a.5.5,0,0,0,.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    className: "cls-1",
    d: "M11.5,8v4a.5.5,0,0,0,1,0V8a.5.5,0,0,0-1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    className: "cls-1",
    d: "M15,0A15,15,0,1,0,30,15h0A15,15,0,0,0,15,0m0,29A14,14,0,1,1,29,15,14,14,0,0,1,15,29h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    className: "cls-1",
    d: "M16.06,23.93a8.36,8.36,0,0,1-2.12,0,.5.5,0,0,0-.55.44.49.49,0,0,0,.43.56,10.26,10.26,0,0,0,2.35,0,.5.5,0,0,0,.45-.55.49.49,0,0,0-.54-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    className: "cls-1",
    d: "M21.94,8.49a.51.51,0,0,0-.06.7,9,9,0,0,1-.53,12.18.5.5,0,0,0,0,.7.5.5,0,0,0,.71,0l0,0a10,10,0,0,0,.59-13.53.49.49,0,0,0-.7-.06h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    className: "cls-1",
    d: "M11.65,6.6a.47.47,0,0,0,.17,0,9.05,9.05,0,0,1,5.3-.33.5.5,0,0,0,.61-.37.5.5,0,0,0-.37-.6,10.13,10.13,0,0,0-5.89.36.52.52,0,0,0-.29.65.51.51,0,0,0,.47.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    className: "cls-1",
    d: "M6,15A8.9,8.9,0,0,1,7.72,9.71a.5.5,0,0,0-.8-.6h0a10,10,0,0,0,1,12.94.5.5,0,0,0,.71,0,.5.5,0,0,0,0-.71A8.94,8.94,0,0,1,6,15"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPlace);
export default __webpack_public_path__ + "static/media/in-place.367c985303e7b5979404892353ff1005.svg";
export { ForwardRef as ReactComponent };